import React from 'react'
type Props = {
  width?: string
  height?: string
  color?: string
}
function Paused({ width = '24', height = '24', color = '#6268AF' }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='12'
        cy='12'
        r='12'
        fill='#F4821F'
      />
      <path
        d='M10.9792 13.5V10.75M13.2708 13.5V10.75M10.2 16.25H14.05C14.8201 16.25 15.2051 16.25 15.4992 16.1001C15.758 15.9683 15.9683 15.758 16.1001 15.4992C16.25 15.2051 16.25 14.8201 16.25 14.05V10.2C16.25 9.42993 16.25 9.04489 16.1001 8.75076C15.9683 8.49204 15.758 8.28169 15.4992 8.14987C15.2051 8 14.8201 8 14.05 8H10.2C9.42993 8 9.04489 8 8.75076 8.14987C8.49204 8.28169 8.28169 8.49204 8.14987 8.75076C8 9.04489 8 9.42993 8 10.2V14.05C8 14.8201 8 15.2051 8.14987 15.4992C8.28169 15.758 8.49204 15.9683 8.75076 16.1001C9.04489 16.25 9.42993 16.25 10.2 16.25Z'
        stroke='white'
        strokeWidth='1.2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default Paused
